const translation = {
  es: {
    errorMessages: {
      "auth/wrong-password": "Contraseña incorrecta",
      'auth/user-not-found': 'Usuario no encontrado',
      'auth/email-already-exists':''
    },
  },
  en: {
    errorMessages: {
      "auth/wrong-password": "Wrong password",
      'auth/user-not-found': 'User not found',
      'auth/email-already-exists':''
    },
  },
};

export default translation;
